"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("../../components/icon"));

var _inputIconToggle = _interopRequireDefault(require("./input-icon-toggle.style"));

var _validationIcon = _interopRequireDefault(require("../validations/validation-icon.component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const shouldDisplayValidationIcon = ({
  error,
  warning,
  info
}) => {
  const validation = error || warning || info || null;
  return typeof validation === "string";
};

const InputIconToggle = ({
  disabled,
  readOnly,
  size,
  inputIcon: type,
  onClick,
  onFocus,
  onBlur,
  onMouseDown,
  error,
  warning,
  info,
  useValidationIcon,
  align,
  iconTabIndex
}) => {
  if (useValidationIcon && !disabled && shouldDisplayValidationIcon({
    error,
    warning,
    info
  })) {
    return /*#__PURE__*/_react.default.createElement(_inputIconToggle.default, {
      size: size
    }, /*#__PURE__*/_react.default.createElement(_validationIcon.default, {
      error: error,
      warning: warning,
      info: info,
      size: size,
      onClick: onClick,
      onFocus: onFocus,
      onBlur: onBlur,
      isPartOfInput: true,
      tabIndex: iconTabIndex,
      tooltipPosition: align === "right" ? "left" : "right"
    }));
  }

  if (type && !(disabled || readOnly)) {
    return /*#__PURE__*/_react.default.createElement(_inputIconToggle.default, {
      size: size,
      onClick: onClick,
      onFocus: onFocus,
      onBlur: onBlur,
      onMouseDown: onMouseDown,
      tabIndex: iconTabIndex
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      type: type
    }));
  }

  return null;
};

InputIconToggle.propTypes = {
  error: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  warning: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  info: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  inputIcon: _propTypes.default.string,
  size: _propTypes.default.oneOf(["small", "medium", "large"]),
  align: _propTypes.default.oneOf(["left", "right"]),
  useValidationIcon: _propTypes.default.bool,
  iconTabIndex: _propTypes.default.number
};
var _default = InputIconToggle;
exports.default = _default;